document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();
            var target = document.querySelector(this.getAttribute('href'));
            if (target) {
                window.scrollTo({
                    top: target.offsetTop,
                    behavior: 'smooth'
                });
            }
        });
    });
});


// custom js for featured product
// document.addEventListener('DOMContentLoaded', function() {
//     var stockTextBlocks = document.querySelectorAll('.stock-text-block .stock-number');

//     stockTextBlocks.forEach(function(block) {
//       var randomNumber = Math.floor(Math.random() * 10) + 5; // Generates a random number between 5 and 14
//       block.textContent = randomNumber;
//     });
//   });

 document.addEventListener('DOMContentLoaded', function() {
  var stockTextBlocks = document.querySelectorAll('.stock-text-block .stock-number');
  var cachedNumber = getCachedNumber();

  stockTextBlocks.forEach(function(block) {
    updateStockNumber(block, cachedNumber);
  });

  function updateStockNumber(block, cachedNumber) {
    var currentNumber;
    var targetNumber = getRandomNumber(4, 10);

    if (cachedNumber && !isCacheExpired()) {
      currentNumber = cachedNumber;
    } else {
      currentNumber = getRandomNumber(4, 10);
      cacheNumber(currentNumber);
    }

    block.textContent = currentNumber;

    var interval = setInterval(function() {
      if (currentNumber > targetNumber) {
        currentNumber--;
        block.textContent = currentNumber;
      } else {
        clearInterval(interval);
        setTimeout(function() { updateStockNumber(block); }, getRandomNumber(10000, 30000));
      }
    }, getRandomNumber(10000, 30000));
  }

  function getRandomNumber(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  function getCachedNumber() {
    var cachedData = JSON.parse(localStorage.getItem('cachedStockNumber'));
    return cachedData ? cachedData.number : null;
  }

  function cacheNumber(number) {
    var expiration = new Date();
    expiration.setDate(expiration.getDate() + 2); // 2 days from now
    var dataToCache = {
      number: number,
      expiration: expiration.getTime()
    };
    localStorage.setItem('cachedStockNumber', JSON.stringify(dataToCache));
  }

  function isCacheExpired() {
    var cachedData = JSON.parse(localStorage.getItem('cachedStockNumber'));
    return !cachedData || cachedData.expiration < Date.now();
  }
});

document.addEventListener('DOMContentLoaded', function() {
  var productScrollButtons = document.querySelectorAll('.product-scroll-button'); // Use a class selector to target multiple buttons
  productScrollButtons.forEach(function(button) {
    button.addEventListener('click', function(event) {
      event.preventDefault();
      var targetElement = document.querySelector('#product-info'); // Assumes all buttons scroll to the same element
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
});